import { Delete } from '@mui/icons-material';
import { Alert, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { DeleteConfirmationDialog } from '../common/DeleteConfirmationDialog';

interface SetsConfigTopBarActionsProps {
    onDelete: () => Promise<void>;
}

export const SetsConfigTopBarActions = ({
    onDelete,
}: SetsConfigTopBarActionsProps): JSX.Element => {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteError, setDeleteError] = useState<string | null>(null);

    const handleDeleteClick = (): void => {
        setDeleteError(null);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = async (): Promise<void> => {
        try {
            await onDelete();
            setDeleteDialogOpen(false);
        } catch (err) {
            setDeleteError((err as Error).message);
        }
    };

    const handleDeleteCancel = (): void => {
        setDeleteDialogOpen(false);
        setDeleteError(null);
    };

    return (
        <>
            <Tooltip title="Delete config">
                <IconButton
                    aria-label="delete config"
                    color="error"
                    onClick={handleDeleteClick}
                >
                    <Delete />
                </IconButton>
            </Tooltip>
            <DeleteConfirmationDialog
                description="Are you sure you want to delete this sets config? This action cannot be undone."
                open={deleteDialogOpen}
                title="Delete Sets Config"
                onCancel={handleDeleteCancel}
                onDelete={handleDeleteConfirm}
            >
                {deleteError && <Alert severity="error">{deleteError}</Alert>}
            </DeleteConfirmationDialog>
        </>
    );
};
